<template>
    <div>
      <Loading :isLoading="saveLoading" :text="loadText" />
      <Upload :action="uploadImgUrl"  
      :data="uploadParams"
       :format="['jpg','jpeg','png','gif']"   
        accept='.jpg,.jpeg,.png,.gif' 
        :on-format-error="uploadError" 
        :max-size="maxImgSize"
        :on-exceeded-size="checkImgSize"
        :on-success="quillImgSuccess"
        :on-error="quillImagError"
         :show-upload-list="false"
        :before-upload="quillImgBefore"
        style="display: none;">
        <Button ref="imgUploadBtn" style="display: none;" ></Button>     
      </Upload>
       <Upload :action="uploadVivoUrl"  
        :format="['mp4']"
        accept='.mp4' 
        :data="uploadParams"
        :on-format-error="uploadError" 
        :on-exceeded-size="checkVidoSize"
        :on-success="quillVidoSuccess"     
        :show-upload-list="false"
         :on-error="quillVidoError"
        :max-size="maxVidoSize"
        :before-upload="quillVidoBefore"
        style="display: none;"> 
         <Button ref="vidoUploadBtn" style="display: none;" ></Button>     
      </Upload>
      <div>
        <!-- 富文本组件 -->
        <quill-editor   class="editor" v-model="content" :ref="toref" :options="editorOption"  :style="{ height: qillHeight + 'px' }"
          @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)"></quill-editor>
      </div>
      <!-- <div>
        <button @click="showText" style="margin-top: 100px;">打印文字</button>  
      </div> -->
    </div>
  
  </template>
<script>
// 工具栏配置
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
    // ["blockquote", "code-block"],                    // 引用  代码块
    // [{ list: "ordered" }, { list: "bullet" }],       // 有序、无序列表
    // [{ indent: "-1" }, { indent: "+1" }],            // 缩进
    //  [{ size: ["small", false, "large", "huge"] }],   // 字体大小
    //   [{ header: [1, 2, 3, 4, 5, 6, false] }],         // 标题
    [{ color: [] }, { background: [] }],             // 字体颜色、字体背景颜色
    // [{ align: [] }],                                 // 对齐方式
    ["clean"],                                       // 清除文本格式
    ["link", "image", "video"]                       // 链接、图片、视频
];
import { UPLOAD_FILE_API, FILE_SERVER } from '@/api/modules/files';
import { 		qiniuToken 	} from '@/api/modules/product-management/product-management';
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";  
import Loading from '@/components/loading/Loading.vue';
const Delta = Quill.import('delta');
  
export default {
    name:'quill-upload',
    props: {
        /* 编辑器的内容 */
        value: {
            type: String
        },
        uploadData:{
            type:Object,
            default:function (){
                return { updatePath:"" };
            }
        },
        uploadImgUrl: {
            type: String,
            //   default: UPLOAD_FILE_API// 上传的图片服务器地址
            default: 'https://up-z2.qiniup.com/'// 上传的图片服务器地址
        },
        qillHeight:{
            type: Number,
            default: 400 //kb
        },
        uploadVivoUrl: {
            type: String,
            default: 'https://up-z2.qiniup.com/'// 上传的视频服务器地址
        },
        imgServer:{
            type: String,  // 获取图片的服务器地址     
            default:FILE_SERVER// 上传的图片服务器地址  
        },
        /* 图片大小 */
        maxImgSize: {
            type: Number,
            default: 400000 //kb
        },
        /* 视频大小 */
        maxVidoSize: {
            type: Number,
            default: 400000000 //kb
        },
        quillIndex:{
            type:Number,
            default:0
        },
        duration:{
            type:Number,
            default:3600
        },
        toref: {
            type: String,
            default:"quillEditor"
        },
        imgWidth:{
            type: Number,    //默认图片宽度
            default: 300 
        }
    },
    components: { quillEditor, Loading },
    data() {
        return {
            loadText:'图片上传中',
            saveLoading:false,
            imageDomain: this.imageDomain,
            content: this.value,
            uploadParams:{},
            editorOption: {
                theme: "snow", // or 'bubble'
                placeholder: "请输入内容",
                modules: {
                    toolbar: {
                        container: toolbarOptions,
                        handlers: {
                            image: (value) => {
                                if (value) {
                                    this.$refs.imgUploadBtn.$el.click();
                                }
                                else {
                                    this.quill.format("image", false);
                                }
                            },
                            video: (value) => {
                                if (value) {
                                    this.$refs.vidoUploadBtn.$el.click();
                                    // imgUpload
                                }
                                else {
                                    this.quill.format("image", false);
                                }
                            }
                        }
                    }
                }
            }        
        
        };
    },
    watch: {
        value: function () {
            this.content = this.value;
        }
    },
    methods: {
        onEditorBlur() {
            //失去焦点事件
        },
        onEditorFocus() {
            //获得焦点事件
        },
        onEditorChange() {
            //内容改变事件
            this.$emit("input", this.content);
        },
        async  quillImgBefore(file) {
            debugger;
            let fileType = file.type;
            if (fileType === 'image/jpeg' || fileType === 'image/png') {
                this.saveLoading=true;
                this.loadText="图片上传中";
                //   return true;
                let suffix = file.name.substring(file.name.lastIndexOf("."));
                let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;
                await qiniuToken({}).then(res => {
                    this.uploadParams.token = res.data.token;
                    // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                    this.uploadParams.key = filename;
                });
            }
            else {
                this.$Message.error('请插入图片类型文件(jpg/jpeg/png)');
                return false;
            }
    
        },
        // 富文本图片上传前
        quillVidoBefore(file) {
            // 检查文件类型
            if (file.type !== 'video/mp4') {
                this.$Message.error('请上传MP4格式的视频');
                return false;
            }
            const url = URL.createObjectURL(file);
            const filelement = new Audio(url);

            //   await qiniuToken({}).then(res => {
			    //     this.uploadParams.token = res.data.token;
			    //     // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
			    //     this.uploadParams.key = filename;
			    // });
            // 设置视频源
            // const video = document.createElement('video');
            // video.src = URL.createObjectURL(file);

            return new Promise((resolve, reject) => {
                filelement.onloadedmetadata = () => {
                    // 获取视频时长
                    const duration = filelement.duration;

                    // 检查时长是否超标，例如限制为300秒
                    if (duration > this.duration) {
                        this.$Message.error(`上传的视频时长不能超过${this.duration}秒`);
                        reject(new Error('Video duration exceeded'));
                    }
                    else {
                        // resolve(file);
                        let suffix = file.name.substring(file.name.lastIndexOf("."));
                        let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;
                        qiniuToken({}).then(res => {
                            this.uploadParams.token = res.data.token;
                            // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                            this.uploadParams.key = filename;
                            this.saveLoading=true;
                            this.loadText="视频上传中";
                            resolve(file);
                        }).then(err => {
                            reject(new Error('Video duration exceeded'));;

                        });
                    }
                };
            });
        },
        quillImgSuccess(res, file) {            
            let toeval = "this.$refs." + this.toref + ".quill";    
            let quill = eval(toeval);         
            // if (res.code == 0) {
            // 获取光标所在位置
            let imagePath = this.imageDomain + file.response.key;
            let length = quill.selection.savedRange.index;
            // 插入图片  res.url为服务器返回的图片地址
            let range = quill.getSelection();
            // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
            let index = range ? range.index : 0;
            const imageDelta = new Delta()
                .retain(range.index) // 保留插入点之前的内容
                .insert({
                    image:imagePath                 
                }, {
                    // height: '200',
                    width: this.imgWidth
                }).retain(quill.getLength() - range.index - range.length);
              
            quill.updateContents(imageDelta);
            // 调整光标到最后
            quill.setSelection(length + 1);
            this.saveLoading=false;
            // } else {
            //     this.$Message.error("图片插入失败");
            //     this.saveLoading=false;
            // }
        },
        quillImagError(error){
            this.saveLoading=false;
            this.$Message.error("图片上传失败");
        },
        quillVidoSuccess(res, file) {
            // res为图片服务器返回的数据
            // 获取富文本组件实例  
            let toeval = "this.$refs." + this.toref + ".quill";
            let quill = eval(toeval);

            let videoPath = this.imageDomain + file.response.key;
            // // 如果上传成功  
            // if (res.code == 0) {
            // 获取光标所在位置
            let length = quill.selection.savedRange.index;
            // 插入图片  res.url为服务器返回的图片地址      
            let range = quill.getSelection();
            // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
            let index = range ? range.index : 0;
            quill.insertEmbed(length, "video", videoPath);
            //   quill.insertEmbed(length, "image",  'api/storage/upload/'+res.data.fileList[0].fileUuid);
            // 调整光标到最后
            quill.setSelection(length + 1);

            this.saveLoading=false;
            // } else {
            //     this.$message.error("图片插入失败");
            // }
        },
        quillVidoError(err){
            this.saveLoading=false;
            this.$Message.error("视频上传失败");
        },
        // 富文本图片上传失败
        uploadError(request, file) {
            this.saveLoading=false;
            // loading动画消失
            this.$Message.error("图片或者视频插入失败");
        },
        checkImgSize(file, fileList) {
            this.$Notice.warning({
                title: '图片大小超标',
                desc: `允许上传的最大值是${this.maxImgSize}kb,此图片的大小是${Math.round(file.size / 1024)}kb`
            });
        },
        checkVidoSize(file, fileList) {
            this.$Notice.warning({
                title: '视频大小超标',
                desc: `允许上传的最大值是${this.maxVidoSize}kb,此视频的大小是${Math.round(file.size / 1024 / 1024)}kb`
            });
        }
    } 
};
</script>
  
  <style>
    .editor {
      line-height: normal !important;
      height: 192px;
    }
    .quill-img {
      display: none;
    }
    .ql-snow .ql-tooltip[data-mode="link"]::before {
      content: "请输入链接地址:";
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
      border-right: 0px;
      content: "保存";
      padding-right: 0px;
    }
  
    .ql-snow .ql-tooltip[data-mode="video"]::before {
      content: "请输入视频地址:";
    }
  
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: "14px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
      content: "10px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
      content: "18px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
      content: "32px";
    }
  
  
  
    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
      content: "文本";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
      content: "标题1";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
      content: "标题2";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
      content: "标题3";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
      content: "标题4";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
      content: "标题5";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
      content: "标题6";
    }
  
    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
      content: "标准字体";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
      content: "衬线字体";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
      content: "等宽字体";
      
    }
  
    .ql-container {
   
      font-size: 20px;
   }
  </style>
  